import { Search } from '@mui/icons-material'
import { Paper, Typography, useTheme } from '@mui/material'

interface EmptyStateProps {
  icon?: JSX.Element
  title: string
  children?: JSX.Element
}

export default function EmptyState({ icon, title, children }: EmptyStateProps) {
  const theme = useTheme()

  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: theme.palette.background.default,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        p: '2rem'
      }}
    >
      {icon ? icon : <Search fontSize="large" />}
      <Typography color="text.secondary" sx={{ mt: '1rem', textAlign: 'center' }}>
        {title}
      </Typography>
      {children}
    </Paper>
  )
}
